import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { DocumentStatistics, getDocumentStatistics } from 'api/gatedCommunity'
import RoundedPanel, { Label } from 'common/RoundedPanel'
import { Loading } from 'react-admin'

const StatsTab = ({ communityId }: { communityId: string }) => {
  const [statistics, setStatistics] = useState<DocumentStatistics | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchStatistics = async () => {
      setLoading(true)
      try {
        const data = await getDocumentStatistics(communityId)
        setStatistics(data)
        setError(false)
      } catch (err) {
        console.error('Failed to fetch document statistics:', err)
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    fetchStatistics()
  }, [communityId])

  if (loading) {
    return <Loading />
  }

  if (error || !statistics) {
    return (
      <Box padding="20px">
        <RoundedPanel width="600px">
          <Label>Error loading statistics</Label>
        </RoundedPanel>
      </Box>
    )
  }

  return (
    <Box padding="20px">
      <RoundedPanel width="600px">
        <Label>Data Sources Statistics</Label>
        <hr />
        <Label noSelect>Data Sources Total: </Label>{statistics.total}<br />
        <Label noSelect>Data Sources Added (last 30 days): </Label>{statistics.added_last_30_days}<br />
        <Box height={16} />
        <Label noSelect>Data Sources Pending: </Label>{statistics.pending}<br />
        <Label noSelect>Data Sources Approved (last 30 days): </Label>{statistics.approved_last_30_days}<br />
        <Box height={16} />
        <Label noSelect>Data Sources Deleted: </Label>{statistics.deleted_total}<br />
        <Label noSelect>Data Sources Deleted (last 30 days): </Label>{statistics.deleted_last_30_days}<br />
        <Box height={16} />
        <Label noSelect>Data Sources with Errors: </Label>{statistics.errors}<br />
      </RoundedPanel>
    </Box>
  )
}

export default React.memo(StatsTab)
